<template>
    <Modal2
        id="private-message-form"
        :title="$t('message.privateMessage')"
        :show-footer="false"
        @cancel="$emit('close')"
    >
        <b-form @submit.prevent="send">
            <b-form-group id="email-input-group" :label="$t('message.yourMessage')" label-for="message-input">
                <b-form-input
                    id="message-input"
                    v-model="message"
                    v-validate="'required'"
                    :placeholder="$t('message.onlyRepresentative')"
                    autocomplete="off"
                    autofocus
                    name="message"
                    trim
                />
                <span class="text-danger mt-3">{{ errors.first("message") }}</span>
            </b-form-group>

            <b-button class="primary rounded-0" type="submit">
                {{ $t("message.send") }}
            </b-button>
        </b-form>
    </Modal2>
</template>

<script>
import { mapState } from "vuex";
import { sendSocketMessage } from "../utils/socketStream";
import Modal2 from "./common/Modal2.vue";

export default {
    name: "PrivateMessage",
    components: { Modal2 },
    props: {
        conversationId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            message: "",
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            site: (state) => state.site.site,
        }),
    },
    methods: {
        send() {
            this.$validator.validateAll().then((response) => {
                if (response) {
                    sendSocketMessage("user private-message", {
                        userId: this.user._id,
                        username: this.user.name,
                        conversationId: this.conversationId,
                        message: this.message,
                        siteId: this.site._id,
                    });
                    this.$validator.reset();
                    this.$emit("close");
                }
            });
        },
    },
};
</script>

<style scoped></style>
